import React from 'react';

interface LogoTextProps {
  size?: 'sm' | 'md' | 'lg';
}

const LogoText: React.FC<LogoTextProps> = ({ size = 'md' }) => {
  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-3xl'
  };

  return (
    <div className={`ml-3 font-display font-bold leading-none ${textSizes[size]}`}>
      <span className="text-white">Scale</span>
      <span className="bg-gradient-to-r from-cyan-300 to-emerald-300 bg-clip-text text-transparent">Nix</span>
      <span className="block text-[10px] text-slate-400 font-medium tracking-[0.22em] uppercase mt-1.5 font-sans">
        Sovereign AI · Open Source
      </span>
    </div>
  );
};

export default LogoText;
